import React from 'react';

import './styles.css';
import { FaTrash } from 'react-icons/fa';

import documentsServices from '../../../../../services/academy/documentsServices';

export default function StudentDocumentsCardItem(props) {
    async function deleteDocument() {
        // eslint-disable-next-line no-restricted-globals
        if (confirm(`Deseja excluir o documento ${props.tittle}?`)) {
            const response = await documentsServices.deleteStudentDocument(props.studentId, props.id);
            if (response.status === 204) {
                // alert(`Documento ${props.tittle} excluído com sucesso!`);
                props.onDelete(props.index);
            } else
                alert("Erro ao excluir documento, tente novamente!");
        }
    }

    return (
        <li className='student-card-documents-list-item'>
            <a className='student-card-documents-component' target="_blank" rel="noreferrer" href={props.href}>
                <div>
                    <p className='tittle'>{props.tittle}</p>
                    <p className='date'>{props.date ? `Adicionado em ${props.date.split('-').reverse().join('/')}` : "Data não definida"}</p>
                </div>
                <span>{props.type}</span>
            </a>
            {
                props.canDelete ?
                    <button className='red' onClick={deleteDocument}><FaTrash /></button>
                    : []
            }
        </li>
    )
}